<template>
  <div class="grow">
    <div class="st-window">
      <div class="header">
        <span class="text">{{ $t('stranger.directory.title') }}</span>
        <div class="close-button">
          <button class="st-button" @click="close()">X</button>
        </div>
      </div>
      <div class="content">
        <div v-if="step==='search'">
          <img alt="icon" src="/stranger/assets/images/ST_ICONE_ANNUAIRE.png">
          <div class="directory-prompt">{{ $t('stranger.directory.prompt') }}</div>
          <div class="form">
            <div v-if="showError" class="st-error st-blink">{{ error }}</div>
            <div>
              <input type="text" v-model="number" placeholder="_" @focus="focus()" v-on:keyup.enter="submit()">
            </div>
            <div>
              <button class="st-button" @click="submit()">{{ $t('common.buttons.ok') }}</button>
            </div>          
          </div>
        </div>
        <div v-if="step==='result'">
          <div class="result-back">
            <button class="st-button" @click="back()"><img alt="left" src="/stranger/assets/images/ARROW_LEFT_PIXEL.svg"></button>
          </div>
          <div class="result-number">
            {{ formatNumber(foundNumber.number) }}
          </div>
          <div class="result-name">
            {{ foundNumber.name }}
          </div>
          <div class="result-address">
            {{ foundNumber.address }}
          </div>
          <div class="result-address" v-if="foundNumber.number === $strangerStore.directory.extraAddressNumber">
            {{ $t('stranger.directory.closed_line') }}
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import currentGameMixin from "@/mixins/currentGameMixin";
  import axios from "axios";

  export default {
    name: "Directory",

    mixins: [currentGameMixin],

    data: () => ({
      showError: false,
      error: '',
      step: 'search',
      number: '',
      numbers: [],
      foundNumber: null,
    }),

    methods: {
      close() {
        this.$router.push({ name: 'stranger-home' });
      },
      focus() {
        if (this.showError) this.number = '';
      },
      back() {
        this.step = 'search';
        this.foundNumber = null;
      },
      formatNumber(n) {
        return n.replace(/(\d{3})(\d{3})(\d{3})/, "$1 - $2 - $3");
      },
      submit() {
        let n = this.number.replace(/\s+/g, '').replaceAll('-', '');

        if (n === '') return;

        const num1 = /^\d{9}$/g;
 
        if (n.match(num1)) {
          console.log(n);

          if (this.numbers.find((e) => e.number === n))
          {
            this.foundNumber = this.numbers.find((e) => e.number === n);

            if (n === this.$strangerStore.directory.extraAddressNumber) {
              this.$strangerStore.directory.solved = true
              this.$strangerStore.saveState()
            }


            this.step = 'result';
          } else {
            this.error = this.$t('stranger.directory.not_found');
            this.showError = true;
          }
        } else {
          this.error = this.$t('stranger.directory.wrong_format');
          this.showError = true;
        }
      }
    },

    watch: {
      number: function() {
        this.error=''; 
        this.showError=false;
      }
    },

    async mounted() { 
      const { data } = await axios.get('/stranger/data/directory.json');
      this.numbers = data;

      if (this.$strangerStore.directory.solved) {
        let n = this.$strangerStore.directory.extraAddressNumber
        this.step = 'result'
        this.foundNumber = this.numbers.find((e) => e.number === n)
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/stranger.scss';
 
  .st-window {
    .content {
      img {
        max-width: 80px;
      }

      .directory-prompt {
        margin-top: 24px;
        color: $accent-color;
      }

      .st-button img {
        width: 32px;
        padding-top:2px;
        height: 40px;
      }

      .form {
        padding-top: 12px;

        .st-error {
          color: $error-color;
          margin-bottom: 12px;
        }

        input[type="text"] {
          border: 2px solid $light-color;
          border-radius: 0;
          background: transparent;
          color: $light-color;
          padding: 8px;
        }

        .st-button {
          margin-top: 12px;
          padding-top: 2px;
          background: $light-color;

          &:hover {
            background: $accent-color;
          }
        }
      }

      .result-back {
        text-align: left;
      }

      .result-number {
        color: $light-color;
        margin-top: 10px;
      }

      .result-name {
        color: $light-color;
        margin-top: 10px;
      }

      .result-address {
        color: $accent-color;
        margin-top: 10px;
      }
    }
  }

  @media (max-width: 600px) {
    .st-window .form input[type="text"]  {
      width: 100%;
    }
  }
</style>
  